import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ReplaceItemsCommand from './replaceItemsCommand';

/**
 * Set item size command
 *
 * @class SetItemSizeCommand
 * @extends AbstractCommand
 */
export default class SetItemSizeCommand extends ReplaceItemsCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        if (this.replacements.length > 1) {
            return `Set size of ${this.replacements.length} items`;
        }
        return 'Set size of item';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SetItemSizeCommand = SetItemSizeCommand;
